import { render } from "./techSpec.vue?vue&type=template&id=7dd80510&scoped=true"
import script from "./techSpec.vue?vue&type=script&lang=js"
export * from "./techSpec.vue?vue&type=script&lang=js"

import "./techSpec.vue?vue&type=style&index=0&id=7dd80510&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dd80510"]])

export default __exports__